var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      class:
        "sop-state-dialog el-dialog__wrapper__pure" +
        (_vm.hideWindow ? " hide-window" : "") +
        (_vm.isExpand ? "" : " sop-state-dialog-pack-up"),
      attrs: {
        modal: false,
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SOPOperatingState"),
        width: _vm.isExpand ? "500px" : "0px",
        top: "20vh",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "el-dialog__title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.SOPOperatingState")))
        ]),
        _c(
          "button",
          {
            staticClass: "el-dialog__headerbtn",
            staticStyle: { right: "35px" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.isExpand = false
              }
            }
          },
          [_c("i", { staticClass: "el-dialog__close el-icon el-icon-minus" })]
        )
      ]),
      _c(
        "el-scrollbar",
        {
          staticClass: "sop-state-scrollbar",
          staticStyle: { height: "calc(80vh - 70px)" }
        },
        [
          _c(
            "el-row",
            { staticClass: "el-row-item el-row-item-header" },
            [
              _c("el-col", { attrs: { span: 7, offset: 6 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ItemsNBR")))
              ]),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Weight")) + "KGS")
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(" " + _vm._s(_vm.$t("SeaExport.Cubage")) + "M "),
                _c("sup", [_vm._v("3")])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "el-row-item" },
            [
              _c(
                "el-col",
                { staticClass: "sop-state-label", attrs: { span: 6 } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Consignation")))]
              ),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.quantityContract || 0))
              ]),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.weightContract || 0))
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(_vm._s(_vm.job.cubageContract || 0))
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "el-row-item" },
            [
              _c(
                "el-col",
                { staticClass: "sop-state-label", attrs: { span: 6 } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Actual")))]
              ),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.quantityActual || 0))
              ]),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.weightActual || 0))
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(_vm._s(_vm.job.cubageActual || 0))
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "el-row-item" },
            [
              _c(
                "el-col",
                { staticClass: "sop-state-label", attrs: { span: 6 } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChargedWeight")))]
              ),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.chargeWeight || 0) + " M/T")
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "el-row-item" },
            [
              _c(
                "el-col",
                { staticClass: "sop-state-label", attrs: { span: 6 } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Size")))]
              ),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.job.measurements))
              ])
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showContainerInfo,
                  expression: "showContainerInfo"
                }
              ],
              staticClass: "el-row-item"
            },
            [
              _c(
                "el-col",
                { staticClass: "sop-state-label", attrs: { span: 6 } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))]
              ),
              _c("el-col", { attrs: { span: 18 } }, [
                _vm._v(_vm._s(_vm.containerInfo))
              ])
            ],
            1
          ),
          _c("el-row", {
            staticClass: "el-row-item",
            staticStyle: {
              "margin-left": "0",
              "border-bottom": "1px solid #dcdfe6"
            }
          }),
          _c(
            "el-row",
            { staticClass: "el-row-item", staticStyle: { color: "#333333" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row-reverse",
                    "padding-right": "30px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "5px", color: "red" } },
                    [_vm._v(_vm._s(_vm.$t("Message.Exception")))]
                  ),
                  _c("div", {
                    staticClass: "icon-solid-circle-exception",
                    staticStyle: { width: "12px", height: "12px" }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { margin: "0 10px 0 5px", color: "#1F75D5" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Completed")))]
                  ),
                  _c("div", {
                    staticClass: "icon-solid-circle-complete",
                    staticStyle: { width: "12px", height: "12px" }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { margin: "0 10px 0 5px", color: "orange" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HaveInHand")))]
                  ),
                  _c("div", {
                    staticClass: "icon-solid-circle-progress",
                    staticStyle: { width: "12px", height: "12px" }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { margin: "0 10px 0 5px", color: "#BBBBBB" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NotStart")))]
                  ),
                  _c("div", {
                    staticClass: "icon-solid-circle-origin",
                    staticStyle: { width: "12px", height: "12px" }
                  })
                ]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "el-row-item", staticStyle: { color: "#333333" } },
            [
              _c("el-col", { attrs: { span: 7, offset: 6 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Time")))
              ]),
              _c("el-col", { attrs: { span: 7 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Status")))
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(_vm._s(_vm.$t("Message.Operator")))
              ])
            ],
            1
          ),
          _c(
            "el-container",
            [
              _c(
                "el-aside",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "margin-bottom": "12px"
                  },
                  attrs: { width: "25px" }
                },
                [
                  _c(
                    "el-steps",
                    { attrs: { direction: "vertical" } },
                    _vm._l(_vm.sopStates, function(item, index) {
                      return _c("el-step", {
                        key: index,
                        attrs: { icon: "icon-solid-circle-" + item.icon }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-main",
                { staticStyle: { padding: "0" } },
                _vm._l(_vm.sopStates, function(item) {
                  return _c(
                    "el-row",
                    { key: item.label, class: "el-row-item item-" + item.icon },
                    [
                      _c(
                        "el-col",
                        { staticClass: "sop-state-label", attrs: { span: 6 } },
                        [_vm._v(_vm._s(item.label))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "min-height": "1px" },
                          attrs: { span: 7 }
                        },
                        [_vm._v(_vm._s(item.date))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "min-height": "1px" },
                          attrs: { span: 7 }
                        },
                        [_vm._v(_vm._s(item.state))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "min-height": "1px" },
                          attrs: { span: 4 }
                        },
                        [_vm._v(_vm._s(item.operator))]
                      ),
                      item.remark
                        ? _c("el-col", { attrs: { span: 17, offset: 7 } }, [
                            _vm._v(_vm._s(item.remark))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isExpand,
              expression: "isExpand"
            }
          ],
          staticClass: "pack-up",
          on: {
            click: function($event) {
              _vm.isExpand = false
            }
          }
        },
        [_c("div", { staticClass: "el-icon-arrow-right" })]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isExpand,
              expression: "!isExpand"
            }
          ],
          ref: "expandDiv",
          staticClass: "expand",
          on: { mousedown: _vm.onMousedown }
        },
        [
          _c("div", {
            staticClass: "el-icon-circle-close",
            attrs: { no: "1" },
            on: { click: _vm.handleRightClose }
          }),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "13px",
                padding: "1px 5px",
                cursor: "pointer"
              },
              attrs: { no: "2" },
              on: { click: _vm.handleExpand }
            },
            [_vm._v("SOP")]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }